import { FoldersContainer } from "../../../pages/FolderPage/FoldersContainer/FoldersContainer";
import { useGetFolderByOfficeId } from "../../../services/folderService";
import { useGetOfficeById } from "../../../services/officeService";

type Props = {
  officeId?: string;
};

export const OfficeDetailContainer = ({ officeId }: Props) => {
  const { data: folders } = useGetFolderByOfficeId(officeId);
  const { data: office } = useGetOfficeById(officeId);

  return (
    <div className="mt-3">
      <h4 className="mb-5">{office ? office.name : ""}</h4>
      <FoldersContainer folders={folders || []} officeId={officeId} />
    </div>
  );
};
